module.exports = __webpack_public_path__ + "2c8a9f55b4b28c5a5d75ea3d5951d9e3.svg";